import { h } from 'preact';
export const Tv = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("rect", { x: "2", y: "7", width: "20", height: "15", rx: "2", ry: "2" }),
        h("polyline", { points: "17 2 12 7 7 2" })));
};
//# sourceMappingURL=tv.js.map